import { render, staticRenderFns } from "./CustomerInputNumber.vue?vue&type=template&id=488375fc&"
import script from "./CustomerInputNumber.vue?vue&type=script&lang=js&"
export * from "./CustomerInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports